import type {
    FetchOptions,
    FetchRequest,
    FetchResponse,
    IFetchError,
} from "ofetch";

export interface ApiErrorResponse {
    message: string;
    errors?: Record<string, string[]>;
}

export default class ApiError<T = unknown> extends Error {
    public override message: string;
    public errors: Record<keyof T | string, string[]> | undefined;
    public request?: FetchRequest;
    public options?: FetchOptions;
    public response?: FetchResponse<T>;

    constructor(
        error: ApiErrorResponse | IFetchError,
        response?: FetchResponse<T>,
    ) {
        super(error.message);

        if ((error as IFetchError).request) {
            this.request = (error as IFetchError).request;
        }

        if ((error as IFetchError).options) {
            this.options = (error as IFetchError).options;
        }

        let data;
        if ((error as IFetchError).response) {
            this.response = (error as IFetchError).response;
            data = (error as IFetchError<ApiErrorResponse>)
                .data as ApiErrorResponse;
        } else {
            data = error;
            this.response = response;
        }

        this.message = data.message;
        this.errors = data?.errors as
            | Record<keyof T | string, string[]>
            | undefined;
    }

    has(key: keyof T | string) {
        return this.errors && this.errors[key];
    }

    get(key: keyof T | string): string[] | undefined {
        return this.errors ? this.errors[key] : undefined;
    }
}
